import React from 'react';
import PropTypes from 'prop-types';
import { graphql, useStaticQuery } from 'gatsby';
import { getSrc } from 'gatsby-plugin-image';

// appsolut base components
import CenteredFooter from '../../components/shapes/Footers/CenteredFooter';

// custom components
import footerRoutes from '../../../config/footer.routes';

function Footer({ logo }) {
  // static query
  const data = useStaticQuery(graphql`
    query {
      siteSetting: datoCmsSiteSetting {
        title
        company
        copyright
        logo {
          gatsbyImageData(width: 150)
          alt
        }
        socialMedia {
          profileType
          link
        }
      }
    }
  `);
  const { siteSetting } = data;

  // parameter handling
  const routeLinks = footerRoutes && footerRoutes.links ? footerRoutes.links : [];
  const routeSocials = siteSetting.socialMedia ? siteSetting.socialMedia : [];
  const settingTitel = siteSetting.title ? siteSetting.title : '';
  const settingCopyright = siteSetting.copyright ? siteSetting.copyright : '';
  const settingLogo = siteSetting.logo ? siteSetting.logo : {};
  const settingCompany = siteSetting.company ? siteSetting.company : settingTitel;

  // footer logo
  const hasSettingImage = !!settingLogo;
  const hasParameterImage = !!logo;
  let logoSrc = '../../images/logo.png';
  let logoAlt = `Footer Logo ${settingTitel}`;
  if (hasParameterImage) {
    logoSrc = getSrc(logo.gatsbyImageData);
    logoAlt = logo && logo.alt ? logo.alt : logoAlt;
  } else if (hasSettingImage) {
    logoSrc = getSrc(settingLogo.gatsbyImageData);
    logoAlt = settingLogo && settingLogo.alt ? settingLogo.alt : logoAlt;
  }

  // copyright
  let cr = '';
  if (settingCopyright) cr = settingCopyright;
  else cr = `Copyright © ${new Date().getFullYear()} ${settingCompany} · All rights reserved`;

  const company = {
    name: settingCompany,
    link: '/',
    copyright: cr,
    logo: {
      src: logoSrc,
      alt: logoAlt,
    },
  };

  return <CenteredFooter company={company} links={routeLinks} socials={routeSocials} />;
}

Footer.propTypes = {
  logo: PropTypes.instanceOf(Object),
};

export default Footer;
